<template lang="pug">
.title-filter.abs-right--16MobileOnly.show--smallScreens
  .title-iconFilter.icon-sort(v-if="displaySort" @click="popupSort = true")
  .title-iconFilter.icon-filter(v-if="displayFilter" @click='showPopupOption')
  .title-iconFilter.title-iconLayoutFilter(v-if="displayLayoutOption")
    div.title-iconGrid-or-List(:class='listMode== true ? "title-iconList" : "title-iconGrid"' @click="changeViewMode")
  PopupOption(v-if='popupOption' @filter='filter' :type='filterType' @closePopup="popupOption = !popupOption" @pickdate='enableDatepicker')
  .popup(:style='pickdate? "": "display: none;"')
    .popup-overlay
    DatePicker(
      :startDate='startDate' 
      @filter='filterWithRange' 
      @cancel='disableDateFilter' 
      :date1='start ? start.toLocaleDateString() : ""'
      :date2='end ? end.toLocaleDateString() : ""'
      ref='datepicker' header popup)
  PopupSort(v-if="popupSort" @sortByType="sortByType" @closePopup="popupSort = !popupSort" :sortType="sortType" :sortConfig="sortConfig")
</template>
<script>
import PopupOption from '@/components/modules/mobile/popup_option.vue';
import PopupSort from '@/components/modules/mobile/popup_sort.vue';
import DatePicker from '@/components/modules/date_picker/date_picker.vue';
import { getFilterRange, initCurrentSortByQueryStr } from '@/plugins/tool.js';

export default {
  components: {
    PopupOption,
    PopupSort,
    DatePicker
  },
  props: {
    type: String,
    filterType: String,
    displayFilter: Boolean,
    displaySort: Boolean,
    displayLayoutOption: Boolean,
    listMode: Boolean
  },
  data() {
    let queryParams = this.$route.query.params;
    let start, end;
    if (queryParams) {
      queryParams = JSON.parse(queryParams);
      if (queryParams.startDate && queryParams.endDate) {
        start = new Date(queryParams.startDate);
        end = new Date(queryParams.endDate);
      }
    }
    return {
      popupOption: false,
      popupSort: false,
      pickdate: false,
      startDate: this.$store.state.datePickerConfig.start,
      sortType: '',
      sortConfig: {
        type: 'users',
        defaultSortType: 'time-1'
      },
      start: start,
      end: end
    };
  },
  created() {
    const currentSort = initCurrentSortByQueryStr(
      this.$route.query.params,
      this.type
    );
    this.sortType =
      currentSort && currentSort.type !== null
        ? currentSort.type + currentSort.direction.toString()
        : this.sortConfig.defaultSortType;
    if (this.sortType === 'updatedAt-1')
      this.sortType = this.sortConfig.defaultSortType;
    if (this.$route.path == '/partner') this.sortConfig.type = 'partners';
  },
  methods: {
    showPopupOption() {
      this.popupOption = true;
    },
    filter(type) {
      this.$emit('changeType', type);
      if (type === 'all') {
        this.$emit('filter', type);
      } else {
        var days = getFilterRange(type);
        this.$emit('filter', days[0], days[1]);
      }
      this.popupOption = false;
    },
    filterWithRange(start, end) {
      this.$emit('filter', start, end);
      this.pickdate = false;
    },
    sortByType(sortData) {
      if (sortData.type != null)
        this.sortType = sortData.type + sortData.direction.toString();
      else this.sortType = this.sortConfig.defaultSortType;
      this.$emit('sortByType', sortData);
    },
    enableDatepicker() {
      this.pickdate = true;
      this.$refs.datepicker.focus();
    },
    disableDateFilter() {
      this.pickdate = false;
    },
    changeViewMode() {
      this.$emit('changeViewMode', !this.listMode);
    }
  }
};
</script>
